import {HttpConcern} from "@web-libs/core/http/infrastructure/client-side/use-http.concern";
import {SpecializationRepository} from "@web-libs/features/specializations/domain/specialization.repository";
import {Specialization} from "@web-libs/features/appointments/domain/appointment.types";
import {parseSpecializationsDTO, SpecializationDTO} from "@web-libs/features/appointments/api/dto/appointment-dto.types";

export const createSpecializationRepository = (http: HttpConcern): SpecializationRepository => {

    const getSpecializations = async (instId: string): Promise<Specialization[]> => {

        return http.get<{ content: SpecializationDTO[] }>(`public/institutions/${instId}/specializations`)
            .then(
                (specializationsPage) => {
                    return parseSpecializationsDTO(specializationsPage.content);
                }
            );
    };

    return {
        getSpecializations
    };
};
